import { postersEscapeSpacesAndApostrophes } from "./posters.js";


const _mapsMappedRegions = ['Noguera', 'Urgell', 'Segrià', 'Pallars-Sobirà'];
const _mapsMappedLabels = ['Festa-Major', 'Falles', 'Astronomia'];

function mapsLabel(region, label)
{
    let aux = "";

    if (region)
    {
        aux = "/" + postersEscapeSpacesAndApostrophes(region);
    }

    const value = postersEscapeSpacesAndApostrophes(label);
    if (_mapsMappedLabels.includes(value))
    {
        return (aux + '/' + value);
    }
    return (aux + '/?label=' + value);
}

function mapsTown(region, town)
{
    const value = postersEscapeSpacesAndApostrophes(town);
    if ((value === 'Tàrrega'))
    {
        return ('/Urgell/' + value);
    } else if (value === 'Balaguer')
    {
        return ('/Noguera/' + value);
    } else if (value === 'Lleida')
    {
        return ('/Segrià/' + value);
    }
    // -------------------------------------------------------------------------
    let aux = "";

    if (region)
    {
        aux = "/" + postersEscapeSpacesAndApostrophes(region);
    }

    return (aux + '/?town=' + value);
}

function mapsRegion(region)
{
    const value = postersEscapeSpacesAndApostrophes(region);
    if (_mapsMappedRegions.includes(value))
    {
        return ('/' + value);
    }
    return ('/?region=' + value);
}

export { mapsLabel, mapsTown, mapsRegion };


